import React from "react";
import { Container, colors } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link, useHistory } from "react-router-dom";

const useStyles = makeStyles({
  container: {
    backgroundColor: "#140c41",
    color: "#fff",
    width: "100%",
    paddingTop: 25,
    position: "absolute",
    height: 200,
    bottom: 0,
    "@media (max-width:600px)": {
      height: 380,
    },
  },
  content: {
    height: 180,
    display: "flex",
    flexDirection: "column",
    "@media (max-width:600px)": {
      height: 360,
    },
  },
  logo: {
    height: 30,
    backgroundImage: `url("/images/upkp/Logo_Monochrome.svg")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    margin: 4,
    cursor: "pointer",
  },
  menu: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    "@media (max-width:600px)": {
      flexDirection: "column",
    },
  },
  menuItem: {
    display: "flex",
    "@media (max-width:600px)": {
      flexDirection: "column",
      alignItems: "center",
      marginBottom: 20,
    },
  },
  menuItemTitle: {
    fontWeight: "600",
    fontSize: 18,
  },
  menuItemContent: {
    paddingLeft: 16,
    "& ul": {
      listStyle: "none",
      paddingLeft: 0,
      "@media (max-width:600px)": {
        textAlign: "center",
        marginTop: 8,
      },
    },
    "& ul > li": {
      marginBottom: 8,
    },
    "& ul > li > a": {
      color: "#fff",
      textDecoration: "none",
    },
    "@media (max-width:600px)": {
      paddingLeft: 0,
    },
  },
});

const Footer = () => {
  const classes = useStyles();
  const history = useHistory();

  function gotoBeranda() {
    history.push("/");
  }

  return (
    <div className={classes.container} id="footer">
      <Container maxWidth="lg" className={classes.content}>
        <div className={classes.logo} onClick={gotoBeranda}></div>
        <div className={classes.menu}>
          <div className={classes.menuItem}>
            <div className={classes.menuItemTitle}>PRODUK</div>
            <div className={classes.menuItemContent}>
              <ul>
                <li>
                  <Link to="/product">UP Kapella Plus</Link>
                </li>
                <li>
                  <Link to="/product">UP Kapella</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className={classes.menuItem}>
            <div className={classes.menuItemTitle}>TOKO UPKP</div>
            <div className={classes.menuItemContent}>
              <ul>
                <li>
                  <Link to="/product">Modul</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className={classes.menuItem}>
            <div className={classes.menuItemTitle}>MEDIA SOSIAL</div>
            <div className={classes.menuItemContent}>
              <ul>
                <li>
                  <a
                    href="https://instagram.com/persiapanupkp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PersiapanUPKP
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
